import { List, Select, Space, Spin, Tag } from "antd";
import Avatar from "antd/lib/avatar/avatar";
import Fuse from "fuse.js";
import React, { useEffect, useRef, useState } from "react";

const options = {
  includeScore: true,
  threshold: 0.3,
  keys: [
    "name",
    "directory_bio",
    "email",
    "directory_industry_experience.name",
    "directory_looking",
    "directory_interest_free_text",
    "directory_skills.name",
    "directory_location",
    "directory_title",
    "tags.name",
  ],
};

const discordOptions = {
  includeScore: true,
  threshold: 0.3,
  keys: ["username", "discord_id", "tags.name"],
};
/* 
Props:
placeholder: text for the search bar
items= list, pass in the list to search through
handleSelection: handler for click on a result
platform = for specific options based on platform
*/
const { Option } = Select;
const NewSearch = (props) => {
  // console.log("all ", props);
  const searchResultRef = useRef();
  const [fuse, setFuse] = useState([]);
  const [value, setValue] = useState();
  const [searchMembers, setSearchMembers] = useState();
  const [searchResultCount, setSearchResultCount] = useState(null);
  const [searchResultsVisible, setSearchResultsVisible] = useState(false);
  const search = useRef(null);

  // const [options, setOptions] = useState(props.items);
  useEffect(() => {
    if (props.platform === "discord") {
      setFuse(new Fuse(props.items, discordOptions));
    } else {
      setFuse(new Fuse(props.items, options));
    }
  }, [props.items]);

  // handle click outside to hide search results
  const handleClick = (e) => {
    if (searchResultRef?.current?.contains(e.target)) {
      // inside click
      return;
    }
    setSearchResultsVisible(false);
  };

  // handle click outside
  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  });

  if (!props.items) {
    return <Spin />;
  }
  const onSearch = async (event) => {
    if (event.target.value === "" || event.target.value === null) {
      setSearchMembers([]);
      setSearchResultsVisible(false);
      setSearchResultCount(null);
    } else {
      setSearchResultsVisible(true);
      // const results = search.current.search(event.target.value);
      const results = fuse.search(event.target.value).map((result) => {
        return result.item;
      });
      setSearchMembers(results?.splice(0, 5));
      setSearchResultCount(
        results?.length >= 5 ? results?.length + 5 : results?.length
      );
    }
  };

  /**
   * Purpose: handle click on search result
   * Params: user id
   */
  const handleResultClicked = (id) => {
    window.analytics.track("Searched for a user");
    props.handleSelection(id);
    setSearchResultsVisible(false);
  };

  /**
   * Purpose: show the correct user avatar depending on the platform
   *
   * @param {*} item - the user
   * @returns a tring representing the correct avatar
   */
  const showAvatar = (item) => {
    if (props.platform === "slack") return item.image_32;
    if (props.platform === "discord") {
      if (item.avatar)
        return `https://cdn.discordapp.com/avatars/${item.discord_id}/${item.avatar}.png`;
      return "avatar_slack.png";
    }
    return "avatar_slack.png";
  };

  return (
    <>
      <div className="relative text-gray-600 block w-full ">
        <input
          type="search"
          id="member-search-bar"
          onChange={(e) => onSearch(e, search)}
          className=" bg-purple-white shadow w-full  rounded-md border-0 p-3 focus:ring-dots-yellow text-sm"
          placeholder="Search for a member or tags"
        />
        <div className="absolute right-0 top-0 mt-2 mr-4">
          <img src="./../search.svg" alt="search" />
        </div>
        {searchResultsVisible ? (
          <div
            id="search-results"
            ref={searchResultRef}
            style={{ zIndex: 1000 }}
            className="delay-100 bg-white -mt-1 absolute bg-purple-white shadow w-full z-index: 50 rounded-b-md border-b-0 focus:ring-dots-yellow text-sm"
          >
            <List
              dataSource={searchMembers}
              className="px-5"
              footer={
                searchResultCount ? (
                  <div className="m-0 text-sm text-gray-600 pr-3 text-right ">
                    Total results: {searchResultCount}{" "}
                  </div>
                ) : null
              }
              renderItem={(item) => (
                <List.Item
                  key={item.key}
                  onClick={() => {
                    if (props.platform === "slack")
                      return handleResultClicked(item.key);
                    return handleResultClicked(item.discord_id);
                  }}
                  className="hover:bg-red-100"
                >
                  <Space className="mx-2">
                    <Avatar alt="member" src={showAvatar(item)} />
                    <span>
                      {props.platform === "slack" ? item.name : item.username}
                    </span>
                    <span>
                      {item.tags
                        ? item.tags.map((tag) => <Tag>{tag.name}</Tag>)
                        : ""}
                    </span>
                  </Space>
                </List.Item>
              )}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default NewSearch;
